import {TimelineMax, TweenMax} from 'gsap/all';

$('.portfolio__link-tab').on('click', (e) => {
	e.preventDefault();
	let $this = $(e.currentTarget);

	let id = $this.attr('href');

	let timeline = new TimelineMax({
		onStart() {
			$('.portfolio__link-tab').removeClass('is-active');
			$this.addClass('is-active');
			TweenMax.set($(`${id}`).find('.portfolio__item'), {y: 120,
				autoAlpha: 0});
			$('.portfolio__block').addClass('is-hidden');
			$(`${id}`).removeClass('is-hidden');
		},
	});

	timeline
		.to($('.portfolio__block'), 0.25, {
			autoAlpha: 0,
			clearProps: 'all',
		})
		.add(() => {
			const timeline2 = new TimelineMax();
			const $block = $(`${id}`).find('.portfolio__item');

			$block.each((index, element) => {
				const tl = new TimelineMax()
					.to(element, 0.4,
						{y: 0,
							autoAlpha: 1}, '+=0.05');

				timeline2.add(tl, '-=0.25');
			});
		});
});
